import { flow, get } from 'lodash/fp';

export const getConfigOptions = get('configOptions');
export const getConfigOptionForm = flow(getConfigOptions, get('form'));
export const isLoadingDetails = flow(getConfigOptions, get('isLoadingDetails'));
export const isSaving = flow(getConfigOptions, get('isSaving'));
